import { render, staticRenderFns } from "./LoginSmall.vue?vue&type=template&id=2f6161d8&scoped=true&"
import script from "./LoginSmall.vue?vue&type=script&lang=js&"
export * from "./LoginSmall.vue?vue&type=script&lang=js&"
import style0 from "./LoginSmall.vue?vue&type=style&index=0&id=2f6161d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6161d8",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAppBar,VBtn,VCard,VCol,VContainer,VFooter,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1532393991/src/playtient-web-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f6161d8')) {
      api.createRecord('2f6161d8', component.options)
    } else {
      api.reload('2f6161d8', component.options)
    }
    module.hot.accept("./LoginSmall.vue?vue&type=template&id=2f6161d8&scoped=true&", function () {
      api.rerender('2f6161d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/LoginSmall.vue"
export default component.exports